// extracted by mini-css-extract-plugin
module.exports = {"xpaContainer":"Home_xpaContainer__CWACt","patternContainer":"Home_patternContainer__5asGQ","pattern":"Home_pattern__oal0Z"};